import styled from "styled-components";
import { H2 } from "../H/H.styled";
import { lg, md } from "../../../AppTheme.styled";

const StyledPageTitle = styled(H2)<{ align?: string }>`
  display: inline-block;
  margin-bottom: 20px;
  text-align: ${({ align }) => align || "initial"};

  ${md} {
    margin-bottom: 34px;
  }
  ${lg} {
    margin-bottom: 36px;
  }
`;

export default StyledPageTitle;
